import { UniqueValueConstraint } from '../../enums/unique-value-constraint.enum';
import { UniquenessCheck } from '../../enums/uniqueness-check';

export class UniqueSettingsConfig {
	uniquenessCheck: UniquenessCheck = UniquenessCheck.NeverUnique;
	uniqueValueConstraint: UniqueValueConstraint = UniqueValueConstraint.Flow;

	constructor(init?: Partial<UniqueSettingsConfig>) {
		if (init) Object.assign(this, init);
	}
}
